import React, { forwardRef } from "react";
import { ChatBubbleLeftEllipsisIcon } from "@heroicons/react/24/outline";

const CommentButton = forwardRef(({ onClick, count = 0 }, ref) => {
  return (
    <div className="relative flex flex-col items-center">
      <button
        ref={ref}
        onClick={onClick}
        className="flex items-center space-x-1 hover:bg-gray-100 p-1 rounded-full transition"
      >
        <ChatBubbleLeftEllipsisIcon className="w-5 h-5 text-gray-600" />
        <span className="text-xs text-gray-700">{count}</span>
      </button>
    </div>
  );
});

export default CommentButton;
